import { render, staticRenderFns } from "./infographics.vue?vue&type=template&id=485f54a3&"
import script from "./infographics.vue?vue&type=script&lang=js&"
export * from "./infographics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports